import BaseItem from './BaseItem';

export default class ContactTopic extends BaseItem {
	private name! : string;
	private link! : string;
	private trackingLabel! : string;
	private trackingCategory! : string;
	private _isResult : boolean;

	constructor($ctx : JQuery) {
		super($ctx);
		this.name = this.$ctx.data('name');
		this.link = this.$ctx.data('result-link');
		this.trackingLabel = this.$ctx.data('tracking-label');
		this.trackingCategory = this.$ctx.data('tracking-category');
		this._isResult = !!this.$ctx.data('is-result-container');
		this.init();
	}

	get topicName() {
		return this.name;
	}

	get topicTrackingLabel() {
		return this.trackingLabel;
	}

	get topicTrackingCategory() {
		return this.trackingCategory;
	}

	get isResult() {
		return this._isResult;
	}

	public isLink() {
		return !!this.link;
	}

	public getTitle() {
		return this.$ctx.find('.title').text();
	}
	public isCurrent() : boolean {
		return this.$ctx.hasClass('current');
	}

	protected init() {
		if(!this.$ctx.hasClass('is-result')) {
			this.$ctx.on('click', this.select.bind(this));
		}
	}

	private select() {
		this.step.selectTopic(this);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/ContactTopic.ts